import { Component, OnInit, ViewEncapsulation, HostBinding, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Endpoint, HelpIndex } from '../../../models/enums';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { GenericColDef, CellTemplateType, AlignDirection } from '../../../models/grid-context';
import { GenericGridComponent } from '../../generic-grid/generic-grid.component';
import { IndexSettingsComponent } from '../settings-modal/index-settings/index-settings.component';
import { RepresentationSet } from '../../../models/corpus';
import { Pattern } from '../../../models/pattern';


@Component({
    standalone: false,
    selector: 'res-data-set-configuration-modal',
    templateUrl: './data-set-configuration-modal.component.html',
    styleUrls: ['./data-set-configuration-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DataSetConfigurationModalComponent extends BaseModalComponent implements OnInit {
    @HostBinding('class') classes = 'maximized-component';
    @ViewChild('patternsGrid') patternsGrid: GenericGridComponent;
    @ViewChild('indexSettingsControl') indexSettingsControl: IndexSettingsComponent;

    // modal-info
    modalTitle = 'Data Set Import Configuration';
    modalAutomationId = 'data-set-import-configuration';
    secondaryButtonLabel = 'Close';
    modalHelpIndex = HelpIndex.imports_view_configuration_dlg;
    modalClass = 'data-set-import-config-modal';
    caseDataHandle: string;
    enablePatternDetection = false;
    regexes: Array<Pattern>;
    representationType: RepresentationSet;

    // grid-info
    gridName = 'patterns-grid';
    automationId = 'patterns';

    columnDefs = new Array<GenericColDef>(
        {
            headerName: 'Name',
            field: 'name',
            lockVisible: true,
            automationId: this.automationId,
            width: 95
        },
        {
            headerName: 'Searchable Token Name',
            automationId: this.automationId,
            hide: true,
            valueGetter: function tokenNameGetter(params) {
                return `'` + 'token-' + params.data.name.toLowerCase() + `'`;
            }
        },
        {
            headerName: 'Store Value',
            automationId: this.automationId,
            field: 'storeValue',
            cellTemplateType: CellTemplateType.iconSwitch,
            cellRendererParams: { iconOnClass: 'fa-check color-grey-10' },
            headerAlignDirection: AlignDirection.center,
            width: 90,
            suppressSizeToFit: true
        },
        {
            headerName: 'Description',
            field: 'description',
            automationId: this.automationId,
            width: 95
        },
        {
            headerName: 'Pattern',
            field: 'expression',
            automationId: this.automationId,
            sortBy: 'expression',
        },
        {
            headerName: 'Created By',
            field: 'createdBy',
            sortBy: 'createdBy',
            automationId: this.automationId,
            width: 95
        }
    );

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private commonService: CommonService,
        private restService: RestService,
        private changeDetectionRef: ChangeDetectorRef
    ) {
        super(modalService, modalRef);
    }

    rowClassRules = {
        'disabled-row': () => {
            return true;
        },
        'pattern-changed-row': (param) => {
            if (param?.data?.modified) {
                return true;
            }
            return false;
        }
    };

    ngOnInit(): void {
        this.caseDataHandle = this.modalData.handle;
        this.representationType = this.modalData.representationType;
        if (this.caseDataHandle && this.commonService?.currentProject?.handle) {
            this.restService.post(Endpoint.corpusManager_getRepresentationConfig, {
                corpusHandle: this.caseDataHandle,
                contextHandle: this.commonService.currentProject.handle,
                representationType: this.representationType
            }).then((response) => {
                this.indexSettingsControl.populateIndexSettingsDataFromResponse(response?.representationConfig);
                if (response?.representationConfig) {
                    this.enablePatternDetection = response.representationConfig.enablePatternDetection;
                    this.regexes = response.regexes;
                    this.changeDetectionRef.detectChanges();
                    if (this.enablePatternDetection && this.patternsGrid && this.regexes) {
                        this.patternsGrid.setData(this.regexes);
                    }
                }
            });
        }
    }
}
